module.exports = __webpack_public_path__ + "img/gauge-simple-max.2df0c98b.svg";